import {apiClient, Order, Void, Waiver} from "rp-components"

export interface OrderService {
    getOrder(orderId: string): Promise<Order>
    abandonOrder(orderId: string): Promise<void>
    submitOrder(orderId: string): Promise<Order>
    getRequiredWaiver(entityId: string): Promise<Waiver>
    consentToWaiver(waiver: Waiver): Promise<Waiver>
}

class OrderServiceImpl implements OrderService {
    static instance?: OrderService = undefined

    private constructor() {}

    static getInstance(): OrderService {
        if (OrderServiceImpl.instance == undefined) {
            OrderServiceImpl.instance = new OrderServiceImpl()
        }
        return OrderServiceImpl.instance
    }

    async getOrder(orderId: string): Promise<Order> {
        return apiClient.get(`orders/${orderId}`)
    }

    async abandonOrder(orderId: string): Promise<void> {
        return apiClient.delete(`orders/${orderId}`)
    }

    async submitOrder(orderId: string): Promise<Order> {
        return apiClient.post<Order, Void>(`orders/${orderId}/submit`, {})
    }

    async getRequiredWaiver(entityId: string): Promise<Waiver> {
        return apiClient.get<Waiver>(`consent/entities/${entityId}/user/waivers`)
    }

    async consentToWaiver(waiver: Waiver): Promise<Waiver> {
        return apiClient.post<Waiver, Waiver>(`consent/user/waivers`, waiver)
    }
}

export default OrderServiceImpl.getInstance()